export default __webpack_public_path__ + "static/media/bobababyNFTlogo.939b03af.png";